import React, { useMemo, useState, useEffect } from "react";
import AsyncSelect from "react-select/async";

export const SearchComponent = ({
  labeShow = "title",
  pid,
  title = "",
  onSelection = () => { },
  loadData = () => { },
  defaultInputValue = null, ///when selected string value need toe b assign
  defaultSelectedValue = "", ///when selected object need to be assign
  error = null,
  defaultValue = null,
  customCls = "z-20",
  placeholder = "",
  checkLength = true,
  noOptionsMessage = "Loading..",
  value = null,
  ...others
}) => {
  const [inputValue, setValue] = useState(defaultInputValue);
  const [loadValue, setLoadValue] = useState([]);
  const [selectedValue, setSelectedValue] = useState(defaultSelectedValue);
  const [focusState, setFocusState] = useState(false);
  const handleChange = (value) => {
    onSelection(value);
  };

  const [debounce, setDebounce] = useState({});

  useEffect(() => {
    const { cb, delay } = debounce;
    if (cb) {
      const timeout = setTimeout(cb, delay);
      return () => clearTimeout(timeout);
    }
  }, [debounce]);

  useEffect(() => {
    if (others['data-nusa-enabled'] && others['data-nusa-concept-name']) {
      let elementSelector = document.getElementById(others['id'])?.querySelector('input[aria-autocomplete="list"]');
      if (elementSelector) {
        elementSelector.setAttribute('data-nusa-enabled', 'true');
        elementSelector.setAttribute('data-nusa-enabled', 'true');
        elementSelector.setAttribute('data-nusa-concept-name', others['data-nusa-concept-name']);
        elementSelector.classList.add("width36vw");
      }
    }
  }, []);

  const promiseOptions = (inputValue) =>
    (!checkLength || inputValue?.length > 2 ) &&
    new Promise((resolve) => {
      setDebounce({
        cb: async () => {
          try{
            const resData = await loadData(inputValue);
            resolve(resData);
          }catch(error){
            console.log(error);
          }
        },
        delay: 300, // ms
      });
    });

  const handleInputChange = (newValue, event) => {
    if (event.action === "input-change") {
      // const inputValue = newValue.replace(/\W/g, "");
      setValue(newValue);
    }
  };

  const handleSelectOption = (value, actionObj) => {
    if (actionObj.action === "clear") {
      //navigate to dashboard if not already
      setSelectedValue(null);
      onSelection(null);
      setValue(null);
    } else {
      setSelectedValue(value);
      onSelection(value);
      setValue(value?.[labeShow]);
    }
  };
  let checkValue = {};
  if (selectedValue) {
    checkValue = { value: selectedValue };
  } else {
    checkValue = { inputValue: inputValue };
  }
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: 35,
      minHeight:  35,
      // borderRadius: "7px",
      boxShadow: "none",
      // border: (props.rules && err) ? "1px solid #dc2626" : "1px solid var(--teal-c-900)",
      // '&:hover': {
      //     border: props.rules && err && "1px solid #dc2626"
      // },
      // '&:focus': {
      //     border: props.rules && err && "1px solid #000"
      // }
      zIndex: "100000",

      border: "1px solid #dc2626",
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: "100 ",
    }),
  };
  return (
    <div className="searchComponent  border border-gray-300  rounded  text-left">
      <div
        className={
          error
            ? `relative errorContainer `
            : "relative  "
        }
      >
        <label
          htmlFor="name"
          className={`px-2 absolute bg-gradient-search-label left-2 -mt-px inline-block text-xs font-normal text-black-c-400 ${focusState || selectedValue || inputValue
            ? "-top-2 duration-300 text-xs "
            : "top-3 duration-300"
            }`}
        >
          {title}
        </label>
        <AsyncSelect
          styles={customStyles}
          noOptionsMessage={() => noOptionsMessage}
          onFocus={() => setFocusState(true)}
          onBlur={() => setFocusState(false)}
          getOptionLabel={(e) => { return (((e?.code || e?.Code) ? ((e?.code || e?.Code) + ' - ') : '') + e[labeShow]) }}
          getOptionValue={(e) => e}
          loadOptions={promiseOptions}
          onInputChange={handleInputChange}
          //inputValue={inputValue}
          onChange={handleSelectOption}
          // defaultInputValue={inputValue}
          value={value || selectedValue}
          {...checkValue}
          
          className={`  ui-select-style   ${customCls}`}
          {...others}
          placeholder={placeholder}
        />
       
      </div>
      {error && (
        <p
          style={{
            margin: "6px 0px 0px 6px",
            color: "red",
            fontFamily: "Lato",
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
};
